export default "<div *ngIf=\"doc\">\n    <div *ngIf=\"doc.visibility\">\n        <img src='{{doc.url}}' width=80%>\n    </div>\n</div>"